import ev from "../util/enumValue";

enum AssetType {
    IMAGE = ev('IMAGE', 1),
    VIDEO = ev('VIDEO', 2),
    FONT = ev('FONT', 3),
}

export default AssetType;
